export default function (to, routesAccessModel) {
  if (!to.matched.length) return false;

  const initialValue = {
    validation: true,
    parent: routesAccessModel,
  };

  const validator = to.matched.reduce((acc, matchedRoute) => {
    // Si la validación ya falló en una iteración anterior, no hacemos nada
    if (!acc.validation) {
      return acc;
    }

    const foundRoute = acc.parent.find(
      (modelRoute) => modelRoute.path === matchedRoute.path
    );
    const existRoute = Boolean(foundRoute);

    return {
      validation: acc.validation && existRoute,
      // Si la ruta existe, actualizamos el padre con los hijos encontrados
      // Si no existe, la validación falla y no necesitamos actualizar el padre
      parent: existRoute ? foundRoute.children : parent,
      // parent: existRoute ? foundRoute.children : parent
      // parent: existRoute ? foundRoute.children : null // o un array vacío []
    };
  }, initialValue);

  return validator.validation;
}
